import { gql } from '@apollo/client';
const RANKINGS_BY_DUPRID = gql`
  query getRatingByDUPRId($duprId: String) {
    getRatingByDUPRId(duprId: $duprId)
  }
`;
export default RANKINGS_BY_DUPRID;
